/**
 * Where index.html sends a visitor. It is a shim: SSO embeds that point at
 * it go on to the designer or the app, everyone else to the public site.
 * Kept out of the page as a module so the CSP needs no inline script.
 */
export function indexRedirectTarget(search: string, hash: string): string {
  if (/[?&]embed=1\b/.test(search) || /[?&]sso=/.test(search)) {
    const params = new URLSearchParams(search);
    if (params.get('embed') === '1' && params.get('entry') === 'designer') {
      const flowUid = params.get('workflowUid') || params.get('uid');
      const mode = params.get('mode');
      if (flowUid || mode === 'new' || mode === 'photoExport') {
        if (flowUid) {
          params.set('uid', flowUid);
          params.set('workflowUid', flowUid);
          if (!params.get('intent')) params.set('intent', 'view_workflow');
        }
        return `flow-designer.html?${params.toString()}`;
      }
    }
    const route = hash && hash.length > 1 ? hash : '#workspaces-flows';
    return `app.html${search}${route}`;
  }
  const publicHash = hash && hash.length > 1 ? hash : '#product';
  return `public.html${publicHash}`;
}
